/*
 * @Descripttion: class helper
 * @Author: zenghua.wang
 * @Date: 2021-05-20 16:59:32
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-08-02 09:21:32
 */

const ELEMENT = '-'
const CHILD = '__'

const join = (name, el, symbol) => (el ? name + symbol + el : name)

const prefix = (name, mods) => {
  if (typeof mods === 'string') {
    return join(name, mods, CHILD)
  }

  if (Array.isArray(mods)) {
    return mods.map(item => prefix(name, item))
  }

  const ret = {}
  Object.keys(mods || {}).forEach(key => {
    ret[name + CHILD + key] = mods[key]
  })
  return ret
}

export default {
  methods: {
    setClass(el, mods) {
      const { name } = this.$options

      if (el && typeof el !== 'string') {
        mods = el
        el = ''
      }
      el = join(name, el, ELEMENT)

      return mods ? [el, prefix(el, mods)] : el
    }
  }
}
